module.exports = __webpack_public_path__ + "img/inu_gallery16.4c4ac2b8.jpg";